/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum PeriodsTableColumnEnum {
    TIME_PERIOD = 'TIME_PERIOD',
    PERIOD_TYPE = 'PERIOD_TYPE',
    BUNDLES_STATUS = 'BUNDLES_STATUS'
}
